module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_reichenburg-f39d9a6b8d008f96463283a57b276f6e.png";